import React from 'react';

function BasicStatItem({data, index}) {
    const className = index % 2 === 0 ? 'stat-item light' : 'stat-item';

    const getFormattedData = () => {
        return new Date(data['date'] * 1000).toLocaleString('en-GB').replace(',', '');
    }

    return <div className={className}>
        <div className="result-info">
            <p className="info">ID: {data['game_id']}</p>
            <p className="info">{data['game_name']} <b>{data['scores']}</b></p>
        </div>
        <div className="date-info">
            {getFormattedData()}
        </div>
    </div>
}

export default BasicStatItem;